import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '../../components/Typography';
import { styled } from '../../utils';
export function Header({ image, pageTitle, color, textColor }) {
    return (_jsxs(HeaderStyled, { color: color, children: [image && (_jsx(HeaderMediaStyled, { style: {
                    backgroundImage: `url(${image})`,
                } })), pageTitle && (_jsx(PageTitleStyled, { textColor: textColor, variant: "h2", color: "inherit", children: pageTitle }))] }));
}
const HeaderStyled = styled('header', {
    shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
    backgroundColor: color ?? theme.palette.groupPrimary.lightBlue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    minHeight: '86px',
    [theme.breakpoints.up('lg')]: {
        minHeight: '186px',
    },
}));
const HeaderMediaStyled = styled('div')(({ theme }) => ({
    width: '86px',
    height: '86px',
    backgroundSize: 'cover',
    backgroundPosition: 'left top',
    position: 'absolute',
    borderRadius: '60px',
    overflow: 'hidden',
    left: '24px',
    [theme.breakpoints.down('lg')]: {
        '&:after': {
            content: "''",
            borderRadius: '50%',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '86px',
            height: '86px',
            background: 'rgba(255, 255, 255, 0.59)',
        },
    },
    [theme.breakpoints.up('lg')]: {
        borderRadius: '50%',
        width: '187px',
        height: '187px',
    },
}));
const PageTitleStyled = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'textColor',
})(({ theme, textColor }) => ({
    ...(textColor && {
        color: textColor,
    }),
    position: 'relative',
    zIndex: 1,
    padding: theme.spacing(1),
    textAlign: 'center',
}));
